export const SUPPORTS_REG_EXP = typeof RegExp !== "undefined";
